import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_56_1662)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.57374 0.526248C3.97509 1.08083 2.59642 2.13346 1.64023 3.5295C0.684041 4.92554 0.200732 6.59143 0.261296 8.28245C0.32186 9.97348 0.923104 11.6005 1.97671 12.9246C3.03032 14.2486 4.48077 15.1999 6.11499 15.6387C7.4399 15.9806 8.828 15.9956 10.16 15.6825C11.3666 15.4115 12.4822 14.8317 13.3975 14C14.3501 13.1079 15.0415 11.9731 15.3975 10.7175C15.7844 9.35208 15.8532 7.91616 15.5987 6.52H8.15874V9.60625H12.4675C12.3814 10.0985 12.1968 10.5683 11.9249 10.9875C11.653 11.4068 11.2993 11.7669 10.885 12.0462C10.3588 12.3943 9.76574 12.6285 9.14374 12.7337C8.51992 12.8497 7.88006 12.8497 7.25624 12.7337C6.62398 12.603 6.02587 12.3421 5.49999 11.9675C4.65518 11.3695 4.02084 10.5199 3.68749 9.54C3.34851 8.54174 3.34851 7.45951 3.68749 6.46125C3.92478 5.76152 4.31703 5.12442 4.83499 4.5975C5.42773 3.98343 6.17816 3.54449 7.00394 3.32884C7.82972 3.11319 8.69894 3.12916 9.51624 3.375C10.1547 3.57099 10.7386 3.91342 11.2212 4.375C11.7071 3.89166 12.1921 3.40708 12.6762 2.92125C12.9262 2.66 13.1987 2.41125 13.445 2.14375C12.7082 1.45809 11.8433 0.924569 10.9 0.573748C9.18212 -0.0500151 7.30246 -0.0667781 5.57374 0.526248Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.57372 0.526245C7.3023 -0.067184 9.18196 -0.0508623 10.9 0.572495C11.8435 0.925699 12.708 1.46179 13.4437 2.14999C13.1937 2.41749 12.93 2.66749 12.675 2.92749C12.19 3.41166 11.7054 3.89416 11.2212 4.37499C10.7385 3.91342 10.1547 3.57098 9.51622 3.37499C8.69919 3.1283 7.82999 3.1114 7.00399 3.32617C6.178 3.54094 5.42711 3.97907 4.83372 4.59249C4.31576 5.11941 3.9235 5.75652 3.68622 6.45624L1.09497 4.44999C2.02248 2.6107 3.62841 1.20377 5.57372 0.526245Z",
				fill: "#E33629"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.40756 6.43751C0.546836 5.74725 0.778064 5.0788 1.09506 4.45001L3.68631 6.46126C3.34733 7.45952 3.34733 8.54175 3.68631 9.54001C2.82298 10.2067 1.95923 10.8767 1.09506 11.55C0.301498 9.97041 0.0594757 8.17064 0.40756 6.43751Z",
				fill: "#F8BD00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.15876 6.51874H15.5988C15.8533 7.9149 15.7844 9.35082 15.3975 10.7162C15.0416 11.9718 14.3501 13.1067 13.3975 13.9987C12.5613 13.3462 11.7213 12.6987 10.885 12.0462C11.2996 11.7666 11.6535 11.4061 11.9254 10.9864C12.1973 10.5667 12.3817 10.0964 12.4675 9.60374H8.15876C8.15751 8.57624 8.15876 7.54749 8.15876 6.51874Z",
				fill: "#6998D4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.09375 11.55C1.95792 10.8833 2.82167 10.2133 3.685 9.53998C4.01901 10.5202 4.65426 11.3698 5.5 11.9675C6.02751 12.3403 6.62691 12.5991 7.26 12.7275C7.88382 12.8435 8.52368 12.8435 9.1475 12.7275C9.76949 12.6222 10.3626 12.388 10.8888 12.04C11.725 12.6925 12.565 13.34 13.4012 13.9925C12.4861 14.8246 11.3705 15.4048 10.1637 15.6762C8.83176 15.9894 7.44365 15.9743 6.11875 15.6325C5.07088 15.3527 4.09209 14.8595 3.24375 14.1837C2.34583 13.4708 1.61244 12.5724 1.09375 11.55Z",
				fill: "#319F43"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_56_1662",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgGoogle;
